// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"94accdd2","182":"a44191e7","453":"c59897ff"}[chunkId] + ".chunk.js";
};